<script>
import CTable from "@/base/common/index.vue";
import {getAliData} from "@/api/forecastManagement/billForecast";

export default {
  name: "AliData",
  components: {CTable},
  data() {
    return {
      fields:[
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          copy: true,
          key: "airway_number",
          fixed: "left",
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          header: {
            copy: true
          },
          width: 180
        },
        {
          name: () => this.$t("客户单号"),
          key: "client_refer_code",
          align: "center",
          width: 190
        },
        {
          name: () => this.$t("账单号"),
          key: "bill_number",
          align: "center",
          width: 190
        },
        {
          name: () => this.$t("支付描述"),
          key: "payment_time",
          align: "center",
        },
      ],
      header: {
        searchs: [
          {
            key: "paymentStatus",
            component: "Select",
            placeholder() {
              return '支付状态';
            },
            clearable: true,
            options: [{label: '已支付', value: 'YES'}, {label: '未支付', value: 'NO'}],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "exceptionStatus",
            component: "Select",
            placeholder() {
              return '是否异常';
            },
            clearable: true,
            options: [{label: '有异常', value: 'YES'}, {label: '无异常', value: 'NO'}],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "hasAssignCharge",
            component: "Select",
            placeholder() {
              return '是否报价';
            },
            clearable: true,
            options: [{label: '已报价', value: 'YES'}, {label: '未报价', value: 'NO'}],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input",
          }
        ],
      },
      methods: {
        list: getAliData
      },
      modals: {},
      config: {
        height: 630,
        // 注意：不要设 isGetList: true —— cTable 的 mounted 里是 `if (!this.config.isGetList) this.getList()`，
        // 为 true 会跳过首次请求（那种情况需要页面自己在 mounted/activated 里调 this.$refs.table.getList()）
        isGetList: true
      }
    }
  }
}
</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table" />
</template>

<style scoped>

</style>
